var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error)?_c('div',{staticClass:"text-danger text-center font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('error.auth'))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }